import { openUrl } from '@kakaopay-common/payweb-bridge';
import { Browser } from '@kakaopay-common/user-agent';

/**
 * 페이웹뷰의 경우 openUrl을 통해 새로고침하고, 그 외의 경우에는 window.location.reload를 통해 새로고침.
 * (openUrl을 통해 새로고침할 경우 x-auth 헤더 등 페이지가 최초에 열리는 경우와 같이 동작한다.)
 */
export const reload = () => {
  if (Browser.isPayWebview()) {
    openUrl(window.location.href);
  } else {
    window.location.reload();
  }
};
